import { render, staticRenderFns } from "./ErrorPreviewDialog.vue?vue&type=template&id=22fbed30&scoped=true&"
import script from "./ErrorPreviewDialog.vue?vue&type=script&lang=ts&"
export * from "./ErrorPreviewDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorPreviewDialog.vue?vue&type=style&index=0&id=22fbed30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fbed30",
  null
  
)

export default component.exports